import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('bank-account.routes.index'),
        name: 'bank_account.index',
        child: false,
        component: () =>
            import(
                /* webpackChunkName: "bank-accounts" */ '@/views/bank-accounts/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('bank-account.breadcrumbs.index'),
                    to: { name: 'bank_account.index' },
                    disable: true,
                },
            ],
            showName: i18n.t('bank-account.breadcrumbs.index'),
        },
    },
    {
        path: '/' + i18n.t('bank-account.routes.create'),
        name: 'bank_account.create',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "bank-accounts" */ '@/views/bank-accounts/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('bank-account.breadcrumbs.index'),
                    to: { name: 'bank_account.index' },
                    disable: false,
                },
                {
                    text: i18n.t('bank-account.breadcrumbs.create'),
                    to: { name: 'bank_account.create' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('bank-account.routes.edit') + '/:id',
        name: 'bank_account.edit',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "bank-accounts" */ '@/views/bank-accounts/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('bank-account.breadcrumbs.index'),
                    to: { name: 'bank_account.index' },
                    disable: false,
                },
                {
                    text: i18n.t('bank-account.breadcrumbs.edit'),
                    to: { name: 'bank_account.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
